export enum PaymentAmountType {
    MANUAL = 'manual',
    ITEMS = 'items',
    SPLIT = 'split',
    FULL = 'full',
    NONE = 'none',
}